<template>
	<div>
		<div class="variable-items">
			<div v-for="(variable, index) in localDataVariables" :key="index" class="variable-item">
				<!-- <div class="head">
					<a href="#" @click="remove(index)" class="remove">حذف</a>
					{{ variable.name }}
					<a href="#" @click="edit(index)" class="edit">ویرایش</a>
				</div>
				<div class="value">
					{{ variable.staticValue ? variable.staticValue : 'مقدار داینامیک' }}
				</div> -->
				<div class="left-side-actions">
					<button class="action-btn-sm edit-btn" @click="edit(index)">
						<i class="fas fa-pen-to-square"></i>
					</button>
					<button class="action-btn-sm remove-btn" @click="remove(index)">
						<i class="fas fa-trash-can"></i>
					</button>
					<button class="action-btn-sm add-btn" @click="addToColumns(index)">
						<i class="fas fa-plus"></i>
					</button>
				</div>
				<div class="details-container">
					<div class="main-details">
						<div class="qd-col-form-group">
							<span class="qd-col-form-title">نام:</span>
							<div class="qd-col-form-data input-like-label">{{ variable.name }}</div>
						</div>
						<!-- <div class="qd-col-form-group">
							<span class="qd-col-form-title">مقدار:</span>
							<div class="qd-col-form-data input-like-label" style="width:118px;">{{ variable.staticValue ? variable.staticValue : 'مقدار داینامیک' }}</div>
						</div> -->
					</div>
				</div>
			</div>
			<div class="add" @click="add()"><i class="fal fa-circle-plus add-icon"></i><span>افزودن متغیر جدید</span></div>
		</div>
		<variable-modify v-if="variableVisible" :value="selectedVariableItem" @resolved="resolveModifyVariable" />
	</div>
</template>

<script>

	export default {
		name: 'Variables',
		props: {
			modelValue: {
				type: Object,
			},
		},
		emits: ['update:modelValue', 'add-column', 'remove-column'],
		data() {
			return {
				localDataVariables: [],
				variableVisible: false,
				selectedVariableItem: null,
			}
		},
		watch: {
			localDataVariables: {
				deep: true,
				handler() {
					this.$emit('update:modelValue', this.localDataVariables)
				},
			},
		},
		mounted() {
			this.localDataVariables = [...this.modelValue]
		},
		methods: {
			remove(index) {
				if (confirm('آیا از حذف این متغیر مطمئن هستید؟')) {
					this.$emit('remove-column', { path: this.localDataVariables[index].key })
					this.localDataVariables.splice(index, 1)
				}
			},
			edit(index) {
				this.selectedVariableItem = this.localDataVariables[index]
				this.variableVisible = true
			},
			addToColumns(index) {
				let variableItem = {
					aggregate: '',
					path: 'p' + Date.now().toString(),
					titlePath: 'متغیر:' + this.localDataVariables[index].name,
					type: '',
					fromVariable: {
						left: '',
						right: '',
						targetColumn: '',
						variableKey: this.localDataVariables[index].key,
						separator: ','
					}
				}
				this.$emit('add-column', variableItem)
			},
			add() {
				this.selectedVariableItem = {
					key: 'v' + Date.now().toString(),
					name: '',
					dynamicValue: null,
					staticValue: null,
				}
				this.variableVisible = true
			},
			resolveModifyVariable(resolvedVariable) {
				if (resolvedVariable) {
					let itemIndex = this.localDataVariables.findIndex(
						(v) => v.key === resolvedVariable.key
					)
					if (itemIndex > -1)
						this.localDataVariables[itemIndex] = resolvedVariable
					else this.localDataVariables.push(resolvedVariable)
				}
				this.variableVisible = false
			},
		},
	}
</script>

<style></style>